<template>
  <div
    id="replenishment-footer"
    v-if="accountType === 6 || $route.path === '/replenishmentShare'"
  >
    <ul>
      <router-link
        tag="li"
        v-for="item in tabbars"
        :key="item.id"
        :to="item.path"
      >
        <div class="tabbar-icon-wrap">
          <img
            v-if="!item.active"
            class="tabbar-img"
            :src="item.icon"
            alt=""
          />
          <img v-else class="tabbar-img" :src="item.iconActive" alt="" />
          <span
            v-if="item.id === 2 && unreadCount > 0"
            class="tabbar-badge-dot"
          ></span>
        </div>
        <span>{{ item.text }}</span>
      </router-link>
    </ul>
  </div>
</template>

<script>
const MESSAGE_UNREAD_COUNT_KEY = "replenishmentMessageUnreadCount";
const MESSAGE_UNREAD_EVENT = "replenishment-message-unread-change";

export default {
  name: "TabBarReplenishment",
  watch: {
    $route: {
      handler() {
        if (this.$route.path === "/replenishment") {
          this.tabbars[0].active = true;
          this.tabbars[1].active = false;
          this.tabbars[2].active = false;
          return;
        }
        if (this.$route.path === "/replenishmentOrder") {
          this.tabbars[0].active = false;
          this.tabbars[1].active = true;
          this.tabbars[2].active = false;
          return;
        }
        if (this.$route.path === "/replenishmentMine") {
          this.tabbars[0].active = false;
          this.tabbars[1].active = false;
          this.tabbars[2].active = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      accountType: 6,
      unreadCount: 0,
      tabbars: [
        {
          id: 0,
          text: "配货单",
          icon: require("@/assets/image/tab-distribution.png"),
          iconActive: require("@/assets/image/tab-distribution-current.png"),
          path: "/replenishment",
          active: true,
        },
        {
          id: 1,
          text: "订单",
          icon: require("@/assets/image/tabbar52.png"),
          iconActive: require("@/assets/image/tabbar51.png"),
          path: "/replenishmentOrder",
          active: false,
        },
        {
          id: 2,
          text: "我的",
          icon: require("@/assets/image/tab-mine.png"),
          iconActive: require("@/assets/image/tab-mine-current.png"),
          path: "/replenishmentMine",
          active: false,
        },
      ],
    };
  },
  mounted() {
    this.accountType =
      JSON.parse(sessionStorage.getItem("userInfoXpz"))?.accountType || 6;
    this.syncUnreadCount();
    window.addEventListener(MESSAGE_UNREAD_EVENT, this.handleUnreadChange);
  },
  beforeDestroy() {
    window.removeEventListener(MESSAGE_UNREAD_EVENT, this.handleUnreadChange);
  },
  methods: {
    syncUnreadCount() {
      const count = Number(sessionStorage.getItem(MESSAGE_UNREAD_COUNT_KEY) || 0);
      this.unreadCount = Number.isNaN(count) ? 0 : count;
    },
    handleUnreadChange(event) {
      if (event && event.detail && typeof event.detail.count !== "undefined") {
        this.unreadCount = Number(event.detail.count) || 0;
        return;
      }
      this.syncUnreadCount();
    },
  },
};
</script>

<style lang="scss" scoped>
#replenishment-footer {
  width: 100%;
  padding: .1rem 0 .2rem;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 150;
  border-top: .01rem solid #f1f1f1;
}

#replenishment-footer ul {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#replenishment-footer ul li {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.tabbar-icon-wrap {
  position: relative;
}

#replenishment-footer ul li span {
  font-size: .2rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #464646;
}

#replenishment-footer ul li img {
  width: .48rem;
  height: .48rem;
}

.tabbar-badge-dot {
  position: absolute;
  top: -.02rem;
  right: -.04rem;
  width: .1rem;
  height: .1rem;
  border-radius: 50%;
  background: #fe2c55;
}

#replenishment-footer ul .router-link-active {
  span {
    color: #fe2c55;
  }
}
</style>
